
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/TermsOfUse",
      function () {
        return require("private-next-pages/TermsOfUse.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/TermsOfUse"])
      });
    }
  